import * as React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';

const logoUrl = Tgcc.ResolveUrl('~/images/PrimaryLogo.svg');

// Define the types for the props and state if needed
interface PapaJohnsShirtOfTheMonthProps {}
interface PapaJohnsShirtOfTheMonthState {
  error?: string;
}

class PapaJohnsShirtOfTheMonth extends React.Component<PapaJohnsShirtOfTheMonthProps, PapaJohnsShirtOfTheMonthState> {
  state: PapaJohnsShirtOfTheMonthState = {};

  componentDidMount() {
    Request.fetchPapaJohnsShirtOfMonth(
      (shirtDetails) => {
        browserHistory.push(shirtDetails.url);
      },
      (err) => {
        console.error("Failed to fetch current Papa Johns shirt of the month:", err);
        this.setState({ error: "Failed to fetch current Papa Johns shirt of the month" });
      }
    );
  }

  getNextMonthFirstDay(): string {
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    return nextMonth.toLocaleString('default', { month: 'long', day: 'numeric' });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={styles.container}>
          <a href="https://www.thegraphiccowcompany.com/" target="_blank" rel="noopener noreferrer">
            <img src={logoUrl} alt="Company Logo" style={styles.logo} />
          </a>
          <h1 style={styles.header}>Check back {this.getNextMonthFirstDay()} for the shirt of the month.</h1>
          <p style={styles.subheader}>
            In the meantime, check out our other Papa John's designs.
          </p>
          <a href="/PapaJohns/view-designs" rel="noopener noreferrer" style={styles.button}>
            View Designs
          </a>
        </div>
      );
    }

    // Since this component is purely for redirection, we don't render anything
    return null;
  }
}

const mapStateToProps = (state: Tgcc.GlobalState) => ({
  // Your mapping here if needed
});

// Connect the component to the Redux store if needed
export default connect(mapStateToProps)(PapaJohnsShirtOfTheMonth);

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    margin: '40px auto',
  },
  logo: {
    maxWidth: '200px',
    margin: '20px auto',
  },
  header: {
    fontSize: '2em',
    color: '#333',
    marginBottom: '10px',
  },
  subheader: {
    fontSize: '1.2em',
    color: '#666',
    marginBottom: '20px',
  },
  button: {
    display: 'inline-block',
    padding: '10px 20px',
    fontSize: '1em',
    color: '#fff',
    backgroundColor: '#e27558',
    borderRadius: '5px',
    textDecoration: 'none',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  image: {
    marginTop: '20px',
    maxWidth: '100%',
    borderRadius: '10px',
  },
};
